import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { HandDeliveryComponent } from '../hand-delivery/hand-delivery.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-assign-representative-distributer-dailog',
  standalone: false,
  templateUrl: './save-assign-representative-distributer-dailog.component.html',
  styleUrl: './save-assign-representative-distributer-dailog.component.scss'
})
export class SaveAssignRepresentativeDistributerDailogComponent implements OnInit {
  AssignDisRepForm: FormGroup;
  constructor(
    private dialogref: MatDialogRef<SaveAssignRepresentativeDistributerDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    public service: DigisubservicesService) {
    this.AssignDisRepForm = fb.group({
      id: [''],
      disrep1: [''],
      dismode: [''],
      dissubmode: [''],
    });
  }
  distributorList = [];
  subDeliveryModeData = [];
  FilteredsubDistributionModeData = [];
  filteredOptions26: Observable<string[]>;
  filteredOptions27: Observable<string[]>;
  filteredOptions28: Observable<string[]>;

  issueSellerName:any
  id:any
  dis_mode:any
  dis_sub_mode:any
  subDistributionModeData = [];
  objectData:any
  ngOnInit(): void {


    this.issueSellerName = this.data['issueSellerName']
    this.id = this.data['id'];
    this.dis_mode = this.data['dis_mode'];
    this.dis_sub_mode = this.data['dis_sub_mode']
    this.objectData = this.data['objectData']

    if(this.id==""){
 this.id=undefined
    }
    this.AssignDisRepForm.patchValue({
      id:this.id,
      disrep1:this.issueSellerName,
      dismode:this.dis_mode,
      dissubmode: this.dis_sub_mode
    })
    this.service.getDistributorData().subscribe((data) => {
      // console.log(data);
      this.distributorList = data;
    });
    this.service.getSubDeliveryMode().subscribe((data) => {
      this.subDeliveryModeData = data;
    });
    this.service.getSubDistributionMode().subscribe((data) => {
       console.log("Sub Distributer",data);
      this.subDistributionModeData = data;
    });
    this.filteredOptions26 = this.AssignDisRepForm.get(
      'disrep1'
    ).valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter26(name) : this.distributorList.slice()
      )
    );

    this.filteredOptions27 = this.AssignDisRepForm.get(
      'dismode'
    ).valueChanges.pipe(
      startWith(''),
      map((value) =>
        typeof value === 'string' ? value : value.sub_delivery_mode
      ),
      map((sub_delivery_mode) =>
        sub_delivery_mode
          ? this._filter27(sub_delivery_mode)
          : this.subDeliveryModeData.slice()
      )
    );
    this.filteredOptions28 = this.AssignDisRepForm.get(
      'dissubmode'
    ).valueChanges.pipe(
      startWith(''),
      map((value) =>
        typeof value === 'string' ? value : value.subdistributionmode
      ),
      map((subdistributionmode) =>
        subdistributionmode
          ? this._filter28(subdistributionmode)
          : this.FilteredsubDistributionModeData.slice()
      )
    );
  }
  private _filter26(name: string): any[] {
    const filterValue = name;
    return this.distributorList.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }
  private _filter27(sub_delivery_mode: string): any[] {
    const filterValue = sub_delivery_mode;
    return this.subDeliveryModeData.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.sub_delivery_mode.toLowerCase().includes(filterValue)
    );
  }
  private _filter28(subdistributionmode: string): any[] {
    const filterValue = subdistributionmode;
    return this.FilteredsubDistributionModeData.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.subdistributionmode.toLowerCase().includes(filterValue)
    );
  }

  
  assignDistributionMode() {
    let data = {
      disrep: this.AssignDisRepForm.get('disrep1').value,
      dismode: this.AssignDisRepForm.get('dismode').value,
      dissubmode: this.AssignDisRepForm.get('dissubmode').value,
    };
  this.sendData=data;
    // console.log('data', data);

    this.service.addAssignDistributionMode(data).subscribe((_data) => {
      this.id=_data.inserted_id
      window.alert(
        'Distribution Mode Assign to Representative Successfully...'
      );
    });
  }

  dis_mode_show = false;
  sendData:any
  updateassignDistributionMode() {
    debugger
    let data = {
      id: this.id,
      disrep: this.AssignDisRepForm.get('disrep1').value,
      dismode: this.AssignDisRepForm.get('dismode').value,
      dissubmode: this.AssignDisRepForm.get('dissubmode').value,
    };
    this.sendData=data;

    // console.log('data', data);

    this.service.updateAssignDistributionMode(data).subscribe((_data) => {
      window.alert('Distribution Mode Updated Successfully...');
      // this.AssignDisRepForm.reset();
    });
  }

  distributionMode(event, option) {
    if (event.isUserInput) {
      let val = option['id'];
      this.FilteredsubDistributionModeData =
        this.subDistributionModeData.filter((a) => {
          return a['sub_deliver_mode_id'] == val;
        });

      // console.log(this.FilteredsubDistributionModeData);
    }
  }

  closeWithData(): void {
    debugger
    this.objectData.issueSellerName=this.id;
    this.objectData.issueSellerName=this.AssignDisRepForm.value.disrep1;
    this.objectData.dis_sub_mode=this.AssignDisRepForm.value.dissubmode;
    this.objectData.dis_mode=this.AssignDisRepForm.value.dismode;
    const someData = this.objectData;
    this.AssignDisRepForm.reset();
    this.dialogref.close(someData); // Pass data back to Dialog1
  }
  
}
